import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPickupParkingFacility = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m0 0h32v32h-32z",
			fill: "#b91632"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m19.9399 22v-12h2.0649l3.0001 7h-1.0001l3.0633-7h1.9368v12h-2.0001v-4-3-2l.3197.9257-2.3197 5.0743h-1l-2.4495-5.04.4495-.96v2 3 4z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#fff",
			strokeLinecap: "square",
			strokeWidth: 2,
			children: [
				/* @__PURE__ */ _jsx("path", { d: "m4.00024 15.99h2.66c.95 0 1.69-.22 2.21-.65s.78-1.06.78-1.88-.26-1.41-.77-1.83c-.52-.42-1.25-.63-2.22-.63h-2.66v10" }),
				/* @__PURE__ */ _jsx("path", { d: "m12.3 16.39h5.81" }),
				/* @__PURE__ */ _jsx("path", { d: "m15.2 19.29v-5.81" })
			]
		})
	]
});
export default SvgPickupParkingFacility;
